<!--
 * @Author: W9013327 v-maijiahua@oppo.com
 * @Date: 2023-01-04 09:05:40
 * @LastEditors: jordan.lu jordan.lu@oppo.com
 * @LastEditTime: 2024-05-22 20:55:03
 * @FilePath: \community-backendf:\community-frontend\src\components\web\selection.vue
 * @Description: 
-->
<template>
  <el-dropdown
    ref="selectionRef"
    trigger="click"
    @visible-change="onShowSelection"
    @command="onSelected"
    :teleported="teleported"
    :class="fullWidthMode ? 'full-width' : ''"
    :popper-class="`ob-${fullWidthMode ? 'full-' : ''}selection ${poperClass}`"
    :placement="placement"
  >
    <div class="dropdown-seletion" :style="activeColor" @click="addPointEvent">
      <slot>
        <span class="dropdown-seletion-label">{{ seletedData?.label }}</span>
      </slot>
      <svg-icon :class="dropDown ? 'reverse' : ''" :name="iconName" />
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="option in props.options"
          :key="option.value"
          :command="option.value"
        >
          <div v-if="!props.needActive">{{ option.label }}</div>
          <div 
            v-else
            class="select-item"
            :class="seletedData.value === option.value ? 'active' : ''"
          >
            <span>{{ option.label }}</span>
            <svg-icon v-if="seletedData.value === option.value" name="icon-done"/>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>

import { ref, watch ,getCurrentInstance} from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const { proxy } = getCurrentInstance()

const emit = defineEmits(['change'])

const props = defineProps({
  defaultValue: {
    type: [String, Number],
    default: ''
  },
  poperClass: {
    type: String,
    default: ''
  },
  options: {
    type: Array,
    default: () => {
      return []
    }
  },
  needActive: {
    type: Boolean,
    default: false
  },
  fullWidthMode: {
    type: Boolean,
    default: false
  },
  teleported: {
    type: Boolean,
    default: false
  },
  placement: {
    type: String,
    default: 'bottom'
  },
  iconName: {
    type: String,
    default: 'icon-triangle'
  }
})

const selectionRef = ref(null)
const dropDown = ref(false)

const seletedData = ref({})

const activeColor = ref(props.needActive ? 'color: var(--text-secondary)' : 'color: var(--text-primary)')

const addPointEvent = ()=>{
  proxy.$ga('thread_sort')
}

const onShowSelection = (val) => {
  dropDown.value = val
  if (!props.needActive) return 
  activeColor.value = `color: var(--text-${val ? 'primary' : 'secondary'})`
}

const onSelected = (val) => {
  proxy.$ga('thread_sort_option', {
    "action": props.options[val-1]?.label,
  })
  seletedData.value = props.options.find(i => i.value === val)
  emit('change', seletedData.value)
}

watch(() => props.defaultValue, (val) => {
  if ((val !== null) && (val !== '') && !!val.toString()) {
    try {
      seletedData.value = props.options.find(i => i.value === val ) || {}
    } catch {}
  }
  emit('change', seletedData.value)
}, {
  immediate: true,
  deep: true
})

defineExpose({
  selectionRef,
  dropDown
})
</script>

<style lang="postcss" scoped>
.dropdown-seletion {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  cursor: pointer;
  outline: none !important;
  &:active {
    outline: none !important;

  }
  &:focus {
    outline: none !important;
  }
  .svg-icon {
    transition: transform .3s;
    transform: rotate(0deg);
  }
  .reverse {
    transform: rotate(-180deg);
  }
  &-label {
    min-width: 100px;
    text-align: right;
    font-family: 'orbit-M';
  }

}
.select-item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}
.active {
  span {
    color: var(--theme);
  }
  .svg-icon {
    width: 20px;
    height: 20px;
    color: var(--theme);
    margin-left: 16px;
  }
}

.full-width {
  border: none;
  box-shadow: none;
  :deep(.dropdown-seletion) {
    display: flex;
    justify-content: space-between;
    width: 100vw;
    padding: 6px 20px;
    background-color: var(--background-selection);
    box-sizing: border-box;
    outline-style: none;
    span {
      font-size: 14px;
      white-space: nowrap;
    }
  }
}
</style>

<style lang="postcss">

.ob-selection {
  .el-dropdown-menu__item {
    --el-dropdown-menuItem-hover-fill: var(--background-listpressed);
    --el-dropdown-menuItem-hover-color: var(--text-primary);
  }
}
.ob-full-selection {
  box-shadow: none !important;
  inset: unset !important;
  top: 36px !important;
  left: 0 !important;
  .el-dropdown-menu {
    --el-bg-color-overlay: var(--background-selection);
    width: calc(100vw - 40px);
    .select-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
  }
  @media screen and (max-width: 1023px) {
    .el-dropdown-menu {
      --el-border-radius-base: 0;
      width: 100vw !important;
    }
  }
}
</style>